/**
 * This is a TypeGen auto-generated file.
 * Any changes made to this file can be lost when this file is regenerated.
 */

import { ProductDtoBase } from "./ProductDtoBase";

export class FrameProductDto extends ProductDtoBase {
    sizeLabel: string;
    minWidth: number;
    maxWidth: number;
}
